import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrowRight",
  "use": "icon-arrowRight-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-arrowRight\">\r\n<path d=\"M126.1,27.1c-2.8-2.8-7.4-2.8-10.2,0l-10.2,10.1c-2.8,2.8-2.8,7.3,0,10.1l39.1,38.5H7.2c-4,0-7.2,3.2-7.2,7.1v14.3\r\n\tc0,3.9,3.2,7.1,7.2,7.1h137.6l-39.1,38.5c0,0,0,0,0,0c-2.8,2.8-2.8,7.3,0,10l10.2,10.1c2.8,2.8,7.4,2.8,10.2,0L200,100L126.1,27.1z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/home/arrowRight.svg
// module id = OeQi
// module chunks = 13